import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface CheckIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CheckIcon = ({ className, ...props }: CheckIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 13.5L9.38652 16.2135L17 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default CheckIcon;
